import { Card } from "@/components/ui/Card";
import { UsersTable } from "@/pages/settings/UsersTable";
import type { AccessData } from "./_shared";

export function AccessCard({ access }: { access: AccessData }) {
  if (!access.isSuperAdmin) {
    return (
      <Card
        title="Access & users"
        subtitle="Invite people, assign roles, and manage who can sign in."
      >
        <div className="rounded-xl border border-dashed border-zinc-300 dark:border-border p-6 text-center">
          <p className="text-[13px] font-medium text-zinc-700 dark:text-zinc-300">
            Requires admin
          </p>
          <p className="mt-1 text-[12px] text-zinc-500 dark:text-zinc-400">
            Only super-admins can view and manage users. Ask a super-admin to
            grant you access.
          </p>
        </div>
      </Card>
    );
  }

  return (
    <Card
      title="Access & users"
      subtitle="Invite people by email and manage roles. Only invited emails can sign in."
    >
      <UsersTable
        rows={access.users}
        currentEmail={access.currentEmail}
        envSuperAdmins={access.envSuperAdmins}
      />
    </Card>
  );
}
